import { createAction, props } from '@ngrx/store';

export const updateMediaForm = createAction(
  '[App Media] Update Form',
  props<{valid: boolean;
  elementVisual: any;
  dataTosaveVisual: any;
  index: number;
  docpath: string;
  messageType: string; // évite le mot réservé `type`
  action: any;} >()
);
export const resetMediaState = createAction('[MediaApp] Init State');
